var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',[_vm._v("Edit Questionnaire Template")]),_c('QuestionnaireTemplateForm',{on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }